module.exports = __webpack_public_path__ + "static/img/icon3D_popup_upgrade@2x.515b3cb6.png";